<ras-page>
	<main>
		<h1>PAYMENT TERMS</h1>

		<p class="lead">Did you know that you don't need to pay a deposit when moving in? Common payments questions are answered here.</p>

		<h3>Which methods of payment do you accept?</h3>
		<p>When paying online your first month’s rent payment can be made by credit card (VISA or MasterCard). When paying in store your first months rent can be made by either credit card , Zapper, Snapscan or you can make an EFT or direct deposit into our bank account. We do not accept cash or cheques. Thereafter, monthly rentals are strictly payable by debit order.</p>

		<h3>When is my rent due?</h3>
		<p>Rent is due in advance on the first day of each month. Your first instalment is due when you book your unit, thereafter rental will be automatically paid by debit order from your account on the first or second working day of the month.</p>

		<h3>Will I receive a monthly tax VAT invoice?</h3>
		<p>A copy of your storage lease agreement together with your proof of payment serves as a valid VAT invoice for tax SARS purposes. We do not issue invoices.</p>

		<h3>Do you accept Diners Club and American Express?</h3>
		<p>No. We only accept VISA or MasterCard.</p>

		<h3>Is the rental inclusive or exclusive of VAT?</h3>
		<p>The price quoted will always be inclusive of VAT.</p>

		<h3>Are there any other initial costs such as a deposit involved?</h3>
		<p>We do not require a deposit or charge any other administrative costs when moving in.</p>
	</main>
</ras-page>
